import { mapActions } from 'vuex'
import { error } from '@/mixins'

export default {
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),

        /*
         * Use examples:
         *
         * fetch(this.repositories.unidade.create)
         * fetch(this.repositories.unidade.edit, 1)
         * fetch(async () => this.repositories.unidade.edit(1))
         */
        async fetch(promise, ...args) {

            let response = null

            try {

                this.setLoading()

                response = await promise(...args)
            }
            catch (error) {

                this.handleError(error)
            }
            finally  {

                this.unsetLoading()
            }

            return response
        },
    },
    mixins: [error]
}